import { createSelector } from 'reselect';

import getApplicationIdSelector from '/business/shared/state/selectors/application/getApplicationIdSelector';
import getAnnualReviewsApplicationsSelector from './getAnnualReviewsApplicationsSelector';

/**
 * Returns true if the current active application has a pending annual update
 * with a follow-on application already created (in pending_annual_update state).
 * The annual updates tab/page should only be accessible once a supporter has
 * enabled the annual update, which creates the follow-on application.
 */
export default createSelector(
  [getApplicationIdSelector, getAnnualReviewsApplicationsSelector],
  (activeApplicationId, annualReviewApplications): boolean => {
    if (!activeApplicationId || !annualReviewApplications.length) {
      return false;
    }

    return annualReviewApplications.some(
      (app) => app.latestApplicationId === activeApplicationId && app.annualUpdate.hasFollowOnApplication,
    );
  },
);
